import React from 'react';
import { Users, Download, ShieldCheck, Award } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: Users,
    text: '1.000+ Familias'
  }, {
    icon: Download,
    text: 'Descarga Inmediata'
  }, {
    icon: ShieldCheck,
    text: 'Garantía 7 días'
  }, {
    icon: Award,
    text: 'Método Probado'
  }];
  return <div className="bg-white py-8 border-y border-gray-100" data-id="element-223">
      <div className="max-w-6xl mx-auto px-6" data-id="element-224">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-0 divide-y md:divide-y-0 md:divide-x divide-gray-100" data-id="element-225">
          {items.map((item, index) => <div key={index} className="flex flex-col items-center justify-center pt-6 md:pt-0 first:pt-0 md:first:pt-0 px-4" data-id="element-226">
              <item.icon className="w-8 h-8 text-sage-green mb-3" data-id="element-227" />
              <span className="text-charcoal font-bold text-center" data-id="element-228">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}